module.exports = "/fonts/fa-light-300.ttf?c183e1e55f4776c764b0349b484dca03";